<template>
  <div
    class="CMP"
    v-if="isRegister || isEmail || isExamination || isLive || isIntegral || !liveStatus"
  >
    <div>
      <div class="CMP-box">
        <img
          v-if="clientWidth > 768"
          src="https://staticdn.ht-s.cn/se/ciif/2022/common/dialog_h.png"
          alt="CMP-img1"
          srcset=""
        />
        <img
          v-if="clientWidth <= 768"
          src="https://staticdn.ht-s.cn/se/ciif/2022/common/dialog_h.png"
          alt="CMP-img1"
          srcset=""
        />
        <i
          class="close"
          v-if="!isExamination && canClose"
          @click="handleClose"
          v-ga="{ event: 'trk', ec: 'popup', ea: 'close', el: 'close' }"
        ></i>

        <!-- 询问是否已注册 -->
        <div class="CMP1" v-if="isRegister">
          <p>
            欢迎您来到{{ Year }}年工博会，即刻注册报名 <br />
            获取精彩内容。
          </p>
          <div class="btn-box">
            <span
              class="CMP-btn"
              @click="handleRegister"
              v-ga="{ event: 'trk', ec: 'popup', ea: 'confirm', el: 'ok' }"
              >立即注册</span
            >
          </div>
        </div>

        <!-- 邮箱，下载资料 -->
        <div class="CMP5" v-if="isEmail">
          <div class="phone-box fx2">
            <label>邮箱：</label>
            <input
              type="text"
              v-model="email"
              placeholder="请输入邮箱地址"
              value=""
              id="email"
            />
          </div>
          <span
            class="CMP-btn"
            @click="handleEmail"
            v-ga="{
              event: 'trk',
              ec: 'popup',
              ea: 'sentemail',
              el: 'sentemail',
            }"
            >发送到邮箱</span
          >
        </div>

        <!-- 已有奖调研 -->
        <div class="CMP1" v-if="isExamination">
          <p class="examination" v-html="ptext"></p>
          <div class="btn-box">
            <span class="CMP-btn" @click="handleIndex">返回首页</span>
          </div>
        </div>
        <!-- 看直播 -->
        <div class="CMP1" v-if="isLive">
          <p v-html="liveText"></p>
          <div class="btn-box">
            <span class="CMP-btn" @click="handleClose">我知道了</span>
          </div>
        </div>
        <!-- 加积分 -->
        <div class="CMP1" v-if="isIntegral">
          <p v-html="integralText"></p>
          <div class="btn-box">
            <span class="CMP-btn" @click="handleClose">我知道了</span>
          </div>
        </div>
        <!-- 直播未开始 -->
        <div class="CMP1" v-if="!liveStatus">
          <p>直播未开始，更多信息请关注微站首页</p>
          <div class="btn-box">
            <span class="CMP-btn" @click="handleIndex">返回首页</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { UserInfo } from "../../api/index.js";
let nowDate = new Date();
export default {
  props: {
    isRegister: {
      type: Boolean,
      value: false,
    },
    isEmail: {
      type: Boolean,
      value: false,
    },
    isExamination: {
      type: Boolean,
      value: false,
    },
    isLive: {
      type: Boolean,
      value: false,
    },
    isIntegral: {
      type: Boolean,
      value: false,
    },
    ptext: {
      type: String,
      value: "",
    },
    articleName: {
      type: String,
      value: "",
    },
    liveText: {
      type: String,
      value: "",
    },
    integralText: {
      type: String,
      value: "",
    },
    canClose: {
      type: Boolean,
      value: true,
      default: true,
    },
    liveStatus: {
      type: Boolean,
      value: true,
      default: true,
    },
  },
  data() {
    return {
      Year: nowDate.getFullYear(),
      email: "",
    };
  },
  watch: {
    isEmail() {
      this.email = this.userInfo.Email;
    },
  },
  methods: {
    handleClose() {
      const obj = {
        event: "trk",
        ec: "popup",
        ea: "close",
        el: "close",
      };
      dataLayer.push(JSON.parse(JSON.stringify(obj)));
      this.$emit("handleClose");
    },
    handleRegister() {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      let params = this.$route.query;
      this.$router.push({
        name: "Register",
        query: {
          backlink: encodeURIComponent(window.location.href),
          track: params.track ? params.track : "",
          utm_source: params.utm_source ? params.utm_source : "",
          utm_medium: params.utm_medium ? params.utm_medium : "",
          utm_campaign: params.utm_campaign ? params.utm_campaign : "",
          utm_content: params.utm_content ? params.utm_content : "",
          se_sr: params.se_sr ? params.se_sr : "",
          se_md: params.se_md ? params.se_md : "",
          se_ct: params.se_ct ? params.se_ct : "",
        },
      });
    },
    handleEmail() {
      var myregs =
        /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.(com|cn|net)$/;
      if (!this.email) {
        this.$toast("请输入邮箱");
      } else if (!myregs.test(this.email)) {
        this.$toast("邮箱格式不正确");
      } else {
        this.$emit("handleEmail", this.email);
      }
    },
    handleIndex() {
      const obj = { event: "trk", ec: "popup", ea: "survey", el: "homepage" };
      dataLayer.push(JSON.parse(JSON.stringify(obj)));
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      let params = this.$route.query;
      this.$store.commit("activeIndex", 0);
      this.$router.push({
        path: "/Home/Index",
        query: {
          track: params.track ? params.track : "",
          utm_source: params.utm_source ? params.utm_source : "",
          utm_medium: params.utm_medium ? params.utm_medium : "",
          utm_campaign: params.utm_campaign ? params.utm_campaign : "",
          utm_content: params.utm_content ? params.utm_content : "",
          se_sr: params.se_sr ? params.se_sr : "",
          se_md: params.se_md ? params.se_md : "",
          se_ct: params.se_ct ? params.se_ct : "",
        },
      });
    },
  },
  computed: {
    clientWidth() {
      return this.$store.state.clientWidth;
    },
    userInfo() {
      return this.$store.state.userInfo;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>